<div class="status-details">

    <div *ngIf="status.value.id !== null || editMode" class="title-header">
        <div class="title-left">
            <span class="title-text">{{ statusTitle | translate }}</span>
        </div>
        <div class="header-buttons" *ngIf="supervisor">
            <ng-container *ngIf="!editMode">
                <button class="btn-edit" (click)="toggleEditMode()">
                    <span class="material-icons-outlined">edit</span>
                </button>
                <button class="btn-delete" (click)="deleteStatus()">
                    <span class="material-icons-outlined">delete</span>
                </button>
            </ng-container>
            <ng-container *ngIf="editMode">
                <action-button
                    class="btn-save"
                    (actionEvent)="saveStatus($event)"
                    icon="save">
                </action-button>
                <button class="btn-cancel" (click)="toggleEditMode()">
                    <span class="material-icons-outlined">cancel</span>
                </button>
            </ng-container>
        </div>
    </div>

    <empty-details *ngIf="status.value.id === null && !editMode"
                   what="empty.what.status"></empty-details>

    <div *ngIf="status.value.id !== null || editMode" class="status-info-container">

        <div *ngIf="status.value.id !== null && !editMode" class="status-info">
            <table>
                <tr class="info-row">
                    <td><strong class="label">{{ "statusDetails.nameLabel" | translate }}</strong></td>
                    <td><span class="value">{{ status.value.name }}</span></td>
                </tr>
                <tr class="info-row">
                    <td><strong class="label">{{ "statusDetails.colorLabel" | translate }}</strong></td>
                    <td>
                        <div class="color-row">
                            <span class="color-swatch" [style.background-color]="status.value.color"></span>
                            <span class="value">{{ status.value.color }}</span>
                        </div>
                    </td>
                </tr>
            </table>

            <messages
                [form]="statusForm"
                [messagesObserver]="messages"
                [showNonFieldKeys]="TRUE"
                [showFieldName]="TRUE"
                [showFieldKeys]="FALSE">
            </messages>
        </div>

        <form [formGroup]="statusForm" *ngIf="editMode" class="status-form">
            <div class="form-group">
                <label for="name">{{ "statusDetails.nameLabel" | translate }}</label>
                <input type="text" id="name" formControlName="name" />
                <messages [form]="statusForm" [messagesObserver]="messages" fieldname="name"></messages>
            </div>

            <div class="form-group">
                <label for="color">{{ "statusDetails.colorLabel" | translate }}</label>
                <!-- the customer's palette only (#173) -->
                <palette-swatches id="color" formControlName="color"></palette-swatches>
            </div>

            <messages
                [form]="statusForm"
                [messagesObserver]="messages"
                [showNonFieldKeys]="TRUE"
                [showFieldName]="TRUE"
                [showFieldKeys]="FALSE">
            </messages>
        </form>

    </div>
</div>
